import * as actionType from './type';

const INITIAL_STATE = {
    lookupData: [],
    allLookupData: []
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.RECEIVED_GET_ALL_LOOKUP_DATA: {
            return {
                ...state,
                lookupData: action?.payload
            }
        }

        case actionType.RECEIVED_ALL_LOOKUP_DATA: {
            return {
                ...state,
                allLookupData: action?.payload
            }
        }

        default: {
            return {
                ...state
            }
        }

    }
}